export interface NewsArticle {
  id: string;
  title: string;
  date: string;
  author: string;
  category: string;
  summary: string;
  cover: string;
  paragraphs: string[];
  tags: string[];
}

export const newsList: NewsArticle[] = [
  {
    id: "n001",
    title: "《长夜将尽》口碑持续走高，悬疑叙事被赞年度惊喜",
    date: "2026-09-28",
    author: "影评编辑部 · 林墨",
    category: "影片动态",
    summary:
      "凭借冷峻的镜头语言与层层反转的剧情，《长夜将尽》上映后口碑一路走高，被不少观众称为年度悬疑惊喜之作。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20rainy%20neon%20city%20street%20at%20night%20with%20moody%20blue%20and%20warm%20orange%20reflections%2C%20atmospheric%20film%20photography%20editorial%20style&width=800&height=450&seq=qx-news-n001&orientation=landscape",
    paragraphs: [
      "自上映以来，《长夜将尽》凭借扎实的剧本和克制的镜头语言，在观众与影评人之间收获了高度一致的肯定。影片以一起尘封旧案为引，将推理的张力与人性的温度巧妙融合。",
      "不少观众表示，影片最打动人的并非反转本身，而是角色在漫长黑夜中依然选择相信光的勇气。导演陆承舟在采访中提到，他希望拍出一部“有呼吸感”的悬疑片。",
      "从数据来看，影片的话题热度持续攀升，相关讨论涵盖表演、摄影、配乐等多个层面。业内普遍认为，它为类型片创作提供了值得借鉴的新思路。",
      "目前影片仍在热映中，随着口碑发酵，后续表现令人期待。",
    ],
    tags: ["长夜将尽", "悬疑", "口碑"],
  },
  {
    id: "n002",
    title: "古装大剧《长安十二时》宣布启动第二季制作",
    date: "2026-09-22",
    author: "剧集观察 · 苏晴",
    category: "剧集资讯",
    summary:
      "人气古装悬疑剧《长安十二时》正式官宣第二季进入筹备阶段，原班主创团队将悉数回归。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20an%20ancient%20Chinese%20palace%20at%20night%20glowing%20with%20warm%20lanterns%20under%20a%20deep%20blue%20sky%2C%20epic%20television%20drama%20editorial%20style&width=800&height=450&seq=qx-news-n002&orientation=landscape",
    paragraphs: [
      "在首季取得亮眼成绩之后，《长安十二时》官方正式宣布启动第二季制作，并透露将继续沿用原班主创与主要演员阵容。",
      "第一季以“十二时辰”的紧张倒计时结构俘获观众，东方美学与悬疑叙事的结合被认为是其最大的亮点。制作方表示，第二季将在此基础上进一步拓展世界观。",
      "据了解，第二季剧本已进入打磨阶段，预计将在保证质量的前提下尽快与观众见面。剧迷们对此反响热烈，相关话题迅速登上讨论榜单。",
      "业内人士分析，优质剧集的系列化开发，有助于形成稳定的内容品牌与观众期待。",
    ],
    tags: ["长安十二时", "古装", "续订"],
  },
  {
    id: "n003",
    title: "科幻电影《星海迷航》幕后特效解析：宇宙是如何被“造”出来的",
    date: "2026-09-15",
    author: "技术前沿 · 陈默",
    category: "幕后制作",
    summary:
      "从概念设计到最终渲染，《星海迷航》的特效团队耗时数年，只为让观众相信那片星海真实存在。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20spaceship%20among%20colorful%20nebula%20clouds%20and%20stars%2C%20deep%20blue%20space%20with%20glowing%20orange%20stellar%20core%2C%20editorial%20visual%20effects%20style&width=800&height=450&seq=qx-news-n003&orientation=landscape",
    paragraphs: [
      "《星海迷航》中令人震撼的宇宙场景，背后是长达数年的概念设计与技术攻坚。特效团队透露，为了还原星云的层次感，他们开发了全新的体积渲染流程。",
      "“我们不追求单纯的炫技，而是希望观众在看的时候忘了这是特效。”视觉总监在分享中这样说道。",
      "除了宏大的太空奇观，影片中飞船内部的光影细节同样经过精密设计，以服务于角色的情绪表达。",
      "随着国产科幻作品不断涌现，工业化制作流程的建设正成为行业关注的重点。",
    ],
    tags: ["星海迷航", "科幻", "特效"],
  },
  {
    id: "n004",
    title: "《山河故人梦》重映票房稳健，经典魅力历久弥新",
    date: "2026-09-08",
    author: "市场观察 · 郑一鸣",
    category: "市场票房",
    summary:
      "时隔多年再度登上大银幕，《山河故人梦》凭借深沉的人文气质，吸引了新老观众走进影院。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20layered%20misty%20mountains%20and%20a%20wide%20river%20at%20dusk%2C%20deep%20blue%20and%20muted%20orange%20gradient%2C%20editorial%20film%20style&width=800&height=450&seq=qx-news-n004&orientation=landscape",
    paragraphs: [
      "经典影片《山河故人梦》于本月开启特别重映，尽管并非新片，依然吸引了大量观众走进影院重温。",
      "有观众表示，随着年岁增长，再看这部电影会读出不一样的味道。影片关于土地、家族与时间的表达，具有穿越时光的力量。",
      "业内认为，优质作品的重映不仅是市场的补充，也在培养观众的观影习惯与审美趣味。",
      "片方透露，未来或将推出更多幕后特辑，让观众进一步了解影片的创作历程。",
    ],
    tags: ["山河故人梦", "重映", "票房"],
  },
  {
    id: "n005",
    title: "年度刑侦剧《迷雾追凶》收官，结局引发全民热议",
    date: "2026-08-30",
    author: "剧评专栏 · 温以宁",
    category: "剧集资讯",
    summary:
      "《迷雾追凶》迎来大结局，层层反转的收官剧情在社交平台掀起讨论热潮，相关话题持续刷屏。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20rainy%20city%20at%20night%20with%20fog%20and%20police%20light%20reflections%2C%20deep%20blue%20tones%20with%20orange%20flashes%2C%20editorial%20crime%20drama%20style&width=800&height=450&seq=qx-news-n005&orientation=landscape",
    paragraphs: [
      "作为本年度备受关注的刑侦剧，《迷雾追凶》在大结局播出后迅速登上各大话题榜单，观众们对结局的解读众说纷纭。",
      "剧集以跨越十年的连环案件为主线，通过缜密的推理和饱满的人物塑造，构建出极具沉浸感的追凶体验。",
      "不少观众表示，结局虽然出乎意料，但回看前期的伏笔，又觉得情理之中。这种“可回味”的叙事结构获得了普遍好评。",
      "主创团队在收官直播中感谢了观众的支持，并回应了部分争议情节的创作初衷。",
    ],
    tags: ["迷雾追凶", "刑侦", "大结局"],
  },
  {
    id: "n006",
    title: "《王座风云》第三季定档，史诗奇幻再启新章",
    date: "2026-08-21",
    author: "海外剧讯 · 顾念",
    category: "海外剧集",
    summary:
      "备受期待的史诗奇幻剧《王座风云》第三季正式定档，新一季将揭开更多关于王座与预言的神秘面纱。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20vast%20stone%20castle%20on%20a%20cliff%20under%20a%20stormy%20blue%20sky%20with%20warm%20orange%20braziers%2C%20epic%20fantasy%20editorial%20style&width=800&height=450&seq=qx-news-n006&orientation=landscape",
    paragraphs: [
      "在第二季留下诸多悬念之后，《王座风云》第三季官方正式公布定档时间，并放出了首支先导预告。",
      "预告中，分裂的七大王座、暗流涌动的权谋斗争以及神秘力量的苏醒，让粉丝们对剧情走向充满猜测。",
      "制作方表示，第三季在制作规模上全面升级，无论是场景搭建还是特效呈现都将带来更震撼的观感。",
      "随着奇幻题材在全球范围内的持续升温，该剧的回归被寄予厚望。",
    ],
    tags: ["王座风云", "奇幻", "定档"],
  },
  {
    id: "n007",
    title: "从《人间烟火》看治愈系剧集的走红密码",
    date: "2026-08-12",
    author: "文化评论 · 何以安",
    category: "行业观察",
    summary:
      "在快节奏的当下，像《人间烟火》这样温柔治愈的作品为何能引发广泛共鸣？本文试图寻找答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20cozy%20old%20street%20with%20warm%20glowing%20shops%20at%20dusk%2C%20soft%20blue%20evening%20light%20with%20orange%20lamps%2C%20editorial%20warm%20style&width=800&height=450&seq=qx-news-n007&orientation=landscape",
    paragraphs: [
      "近年来，治愈系剧集逐渐成为观众的心头好，《人间烟火》便是其中的典型代表。它没有惊天动地的剧情，却用日常的温暖打动了无数人。",
      "评论认为，这类作品的走红，反映了当下观众对真实情感与生活质感的渴望。在信息过载的时代，温柔反而成为一种稀缺品。",
      "《人间烟火》通过一家小面馆的视角，串联起邻里街坊的悲欢，让观众在平凡中看到生活的光。",
      "或许正如剧中所说：最动人的故事，往往就藏在最普通的日子里。",
    ],
    tags: ["人间烟火", "治愈", "行业观察"],
  },
  {
    id: "n008",
    title: "《破晓行动》发布制作特辑：每一帧都来之不易",
    date: "2026-08-03",
    author: "幕后纪实 · 方铁",
    category: "幕后制作",
    summary:
      "《破晓行动》最新制作特辑曝光，展现了剧组为还原真实战场氛围所付出的巨大努力。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20battlefield%20at%20dawn%20with%20smoke%20and%20distant%20orange%20flare%20against%20a%20deep%20blue%20sky%2C%20gritty%20editorial%20war%20film%20style&width=800&height=450&seq=qx-news-n008&orientation=landscape",
    paragraphs: [
      "作为年度备受期待的动作战争片，《破晓行动》发布的最新制作特辑，让观众得以一窥拍摄现场的艰辛。",
      "为了呈现真实的战场质感，剧组在多个外景地进行了长时间拍摄，演员们也接受了系统的体能与战术训练。",
      "导演高子龙表示，团队坚持尽量使用实景与实拍，希望让观众感受到那份沉甸甸的真实。",
      "特辑发布后，不少观众留言表示，正是这份用心让影片的家国情怀更加动人。",
    ],
    tags: ["破晓行动", "战争", "幕后"],
  },
  {
    id: "n009",
    title: "秋季影视片单前瞻：这些作品值得加入片单",
    date: "2026-07-25",
    author: "编辑推荐 · 江晚",
    category: "编辑推荐",
    summary:
      "入秋以来，多部影视作品陆续定档。我们挑选了几部值得关注的作品，供影迷们参考收藏。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20starry%20night%20sky%20above%20a%20quiet%20city%20with%20soft%20glowing%20lights%2C%20deep%20blue%20palette%20with%20warm%20orange%20lantern%20glow%2C%20editorial%20dreamy%20style&width=800&height=450&seq=qx-news-n009&orientation=landscape",
    paragraphs: [
      "随着秋意渐浓，影视市场也迎来了新一轮的作品发布。从悬疑到治愈，从科幻到年代，类型丰富，佳作频出。",
      "本季片单中，既有备受期待的大制作，也有制作精良的中小成本作品，充分满足了不同观众的观影口味。",
      "编辑团队根据作品完成度、主创阵容与题材新意，筛选出多部值得关注的作品，建议影迷们收藏参考。",
      "当然，好作品需要时间检验，我们也将持续关注它们的市场表现与口碑走向。",
    ],
    tags: ["片单", "推荐", "秋季"],
  },
  {
    id: "n010",
    title: "《最后的棋局》获多项提名，匠人精神引共鸣",
    date: "2026-07-16",
    author: "影评编辑部 · 林墨",
    category: "影片动态",
    summary:
      "以围棋人生为主题的《最后的棋局》斩获多项行业提名，影片所传递的匠人精神引发广泛共鸣。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20traditional%20study%20with%20a%20go%20board%20and%20warm%20lantern%20light%2C%20deep%20blue%20shadows%20and%20amber%20orange%20highlights%2C%20refined%20editorial%20style&width=800&height=450&seq=qx-news-n010&orientation=landscape",
    paragraphs: [
      "《最后的棋局》自上映以来，凭借细腻的情感与深刻的主题收获了大量好评，并在多个行业评选中获得提名。",
      "影片讲述了一位棋坛宗师在人生最后一盘棋中回望过往的故事，将围棋的智慧与人生的抉择巧妙呼应。",
      "不少观众表示，片中对“落子无悔”的诠释，让人重新思考坚持与放下的意义。",
      "主创团队表示，希望这部作品能让更多人感受到传统技艺背后那份专注与敬畏。",
    ],
    tags: ["最后的棋局", "围棋", "提名"],
  },
];